"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PathLayerMapEvents_1 = require("./PathLayerMapEvents");
/* This file encapsulates map events specific for the 'scenarios' section */
const scenarioSectionEventDescriptors = [
    { type: 'layer', layerName: 'transitPathsForServices', eventName: 'mouseenter', handler: PathLayerMapEvents_1.onTransitPathsMouseEnter },
    { type: 'layer', layerName: 'transitPathsForServices', eventName: 'mouseleave', handler: PathLayerMapEvents_1.onTransitPathsMouseLeave }
];
exports.default = scenarioSectionEventDescriptors;
//# sourceMappingURL=ScenarioSectionMapEvents.js.map